import React, { useState } from "react";
import Popup from "../../../App/Common/Popup/Popup";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import "./AnswerComment.css";

function AnswerComments({
  result,
  header,
  resultFilenames,
  currentFilenames,
  resultFileLinks,
  currentFileLinks,
  handlePopUp,
  title,
}) {
  const getDisplayFilename = (filename, maxLength = 15) => {
    console.log(filename);
    const ext = filename.split(".").pop();
    const name = filename.slice(0, filename.lastIndexOf("."));

    if (name.length <= maxLength) {
      return filename;
    }

    return `${name.slice(0, maxLength)}... .${ext}`;
  };
  console.log(result, resultFilenames, resultFileLinks);
  return (
    <Popup onClose={handlePopUp} noButton>
      {/* Заголовок задания */}
      <div className="question__header_wrap">
        {header.typeText}
        <span className="question__header_title" style={{ marginLeft: "10px" }}>
          {header.title}
        </span>
      </div>

      {/* Задание */}
      <div className="comment__headerTask">Задание: {parse(result.text)}</div>

      <div className="fileResult__commentAnswer">
        {/* Ссылки на сторонние ресурсы или файлы */}
        {result?.result_third_party_url || resultFileLinks?.length > 0 ? (
          <div className="comment__inputResult linkResult">
            <div>{result?.result_third_party_url || resultFileLinks}</div>
          </div>
        ) : (
          typeof result.answers !== "object" && (
            <div className="comment__inputResult">
              <div>{result.answers}</div>
            </div>
          )
        )}

        {/* Превью текущих файлов */}
        {currentFilenames && currentFilenames.length > 0 && (
          <div className="comment__previewsResult">
            {currentFilenames.map((filename, index) => (
              <div className="file__previewContainerResult" key={index}>
                <Link to={currentFileLinks[index]} className="file__preview">
                  {index + 1}. {getDisplayFilename(filename)}
                </Link>
              </div>
            ))}
          </div>
        )}

        {/* Превью итоговых файлов */}
        {resultFilenames && resultFilenames.length > 0 && (
          <div className="file__previewsResult">
            {resultFilenames.map((filename, index) => (
              <div className="file__previewContainerResult" key={index}>
                <Link to={resultFileLinks[index]} className="file__preview">
                  {index + 1}. {getDisplayFilename(filename)}
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="fileResult__commentResult">
        {/* Баллы за задание */}
        {result.is_correct !== undefined && (
          <div className="fileResult__commentPoint">
            Баллы <span>{result.is_correct}</span>
          </div>
        )}

        {/* Комментарий к ответу */}
        <div className="fileResult__commentBlock_wrap">
          <div>Комментарий к ответу</div>
          {result?.result_comment ? (
            <div
              className="fileResult__commentBlock"
              style={{ display: "flex", gap: "5px", marginLeft: "20px" }}
            >
              {result?.result_comment}
            </div>
          ) : (
            <div className="fileResult__commentBlock"></div>
          )}
        </div>
      </div>
    </Popup>
  );
}

export default AnswerComments;
